import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["x", "y", "width"]

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    viewportWidth: null,
    viewportHeight: null,
    minX: null,
    maxX: null,
    modelValue: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: "update:modelValue", value: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  viewportWidth: number;
  viewportHeight: number;
  minX: number;
  maxX: number;
  modelValue: number;
}



const totalWidth = computed(() => props.maxX - props.minX);
const hScrollBarWidth = computed(() => {
  if (totalWidth.value === 0) return 0;
  const width =
    (props.viewportWidth / totalWidth.value) * (props.viewportWidth - 10);
  if (width >= props.viewportWidth - 10) return 0;
  return width;
});
const hScrollBarX = computed(() => {
  if (totalWidth.value === 0) return 5;
  return (
    ((props.modelValue - props.minX) / totalWidth.value) *
      (props.viewportWidth - 10) +
    5
  );
});
function down() {
  window.addEventListener("pointermove", move);
  window.addEventListener("pointerup", up);
}
function move(e: PointerEvent) {
  let newX = props.modelValue + e.movementX;
  if (newX > totalWidth.value - props.viewportWidth) {
    newX = totalWidth.value - props.viewportWidth;
  }
  if (newX < 0) newX = 0;
  emit("update:modelValue", newX);
}
function up() {
  window.removeEventListener("pointermove", move);
  window.removeEventListener("pointerup", up);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("rect", {
    x: _unref(hScrollBarX),
    y: __props.viewportHeight - 15,
    width: _unref(hScrollBarWidth),
    height: 10,
    fill: "#aaa",
    rx: 5,
    ry: 5,
    onPointerdown: down
  }, null, 40, _hoisted_1))
}
}

})